import React from 'react';
import { useTranslation } from 'react-i18next';
import PageSubHeaderLayout from '../layouts/PageSubHeaderLayout/PageSubHeaderLayout';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import withAuthentication from '@alphapoint/apex-web/lib/hocs/withAuthentication';
import BalancesListContainer from '@alphapoint/apex-web/lib/components/BalancesList';
import MarketOverviewComponent from '@alphapoint/apex-web/lib/components/MarketOverview';
import RecentActivityContainer from '@alphapoint/apex-web/lib/components/RecentActivity/RecentActivityContainer';
import { Notifications } from '@alphapoint/apex-web/lib/components/Notifications';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import './DashboardPage.css';

const layoutClasses = getBEMClasses('dashboard-page');

const DashboardPage = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className={layoutClasses('accent-bar')} />
      <PageSubHeaderLayout />
      <div className={layoutClasses()}>
        <div className={layoutClasses('notification-row')}>
          <Notifications />
        </div>
        <div className={layoutClasses('market-overview-container')}>
          <div className={layoutClasses('market-overview-container-left')}>
            <div className={layoutClasses('market-header')}>{t('Markets Overview')}</div>
            <MarketOverviewComponent />
          </div>
          <div className={layoutClasses('market-overview-container-right')}>
            <div className={layoutClasses('balances-header')}>{t('Balances')}</div>
            <BalancesListContainer />
          </div>
        </div>
        <div className={layoutClasses('recent-activity-container')}>
          <RecentActivityContainer filterForSelected={false} />
        </div>
      </div>
      <div className={layoutClasses('footer')}>
        <PageFooterLayout />
      </div>
    </React.Fragment>
  );
};

export default withAuthentication(DashboardPage);
